"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatPropsList = flatPropsList;
const fixAndMergeSchema_1 = require("./fixAndMergeSchema");
const schemaPath_1 = require("./schemaPath");
/**
 * zwraca płaską listę elementów schematu
 *
 * @export
 * @param {JSONSchema} schema schemat
 * @param {boolean} [sipleTypesOnly=false] czy zwracać tylko typy proste (pomija object i array)
 * @param {FlatPropsListItem[]} [prevList=[]] dane wewnętrzne
 * @returns {FlatPropsListItem[]} lista zwróconych właściwości
 */
function flatPropsList(schema, sipleTypesOnly = false, prevList = []) {
    if (schema.$parent === undefined) {
        schema = (0, fixAndMergeSchema_1.fixAndMergeSchema)([schema]);
    }
    if (schema.$key) {
        if (sipleTypesOnly) {
            if (schema.type !== 'object' && schema.type !== 'array') {
                prevList.push({
                    path: (0, schemaPath_1.schemaPath)(schema, true).replace('[]', ''),
                    field: schema.$key,
                    schema
                });
            }
        }
        else {
            prevList.push({
                path: (0, schemaPath_1.schemaPath)(schema, true),
                field: schema.$key,
                schema
            });
        }
    }
    if (schema.type === 'object') {
        if (schema.properties) {
            // tslint:disable-next-line: forin
            for (const propName in schema.properties) {
                flatPropsList(schema.properties[propName], sipleTypesOnly, prevList);
            }
        }
    }
    else if (schema.type === 'array') {
        if (schema.items) {
            flatPropsList(schema.items, sipleTypesOnly, prevList);
        }
    }
    return prevList;
}
exports.default = flatPropsList;
//# sourceMappingURL=flatPropsList.js.map